export default {
  ja: {
    List: {
      firstMessage: '下のフォームにタイトルを入力、作成するボタンをクリックしてください。',
      title: 'ポジショニングマップ',
      input: 'タイトルを入力してください',
      createButton: '作成する'
    },
    Workspace: {
      firstMessage: '画面上どこでもいいので、クリックしてみてください。その後はご自由にポジショニングマップの作成をお楽しみください。',
      object: {
        deleteButton: 'Objectを削除する',
        showInCircle: '円の中に表示',
        showAlongCircle: '円に沿って表示'
      },
      setting: {
        deleteButton: 'マップを削除する',
        message: '本当にポジショニングマップを削除していいですか？',
        yesButton: 'はい',
        noButton: 'いいえ'
      }
    }
  }
}
